import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    max-width: 22rem;
    flex-direction: column;
`;

export const Label = styled.label`
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--color-text-muted);
    margin-bottom: 0.35rem;
`;

export const Input = styled.input`
    height: 2.6rem;
    border-radius: 0.4rem;
    border: 1px solid var(--color-border);
    background-color: var(--color-surface-alt);
    color: var(--color-text);
    padding: 0 0.75rem;
    font-family: 'Inter', sans-serif;
    font-size: 0.95rem;

    &:focus {
        outline: none;
        border-color: var(--color-accent);
    }

    &::placeholder {
        color: var(--color-text-muted);
    }
`;
